var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5C13.1838 0.5 13.7817 0.749453 14.2666 1.23438C14.7514 1.71918 15.0007 2.31674 15 3V19.7578L14.3027 19.46L7.5 16.5439L0.697266 19.46L0 19.7578V3C0 2.31633 0.24937 1.7187 0.734375 1.23438C1.21901 0.750566 1.81636 0.500918 2.49902 0.5H12.5ZM1 18.2412L7.30273 15.54L7.5 15.4561L7.69727 15.54L14 18.2412V2.99902C14.0004 2.58404 13.8585 2.24037 13.5596 1.94141C13.2605 1.64234 12.9162 1.5 12.5 1.5H2.50098L2.34766 1.50684C1.99936 1.53859 1.70313 1.68025 1.44141 1.94141C1.14261 2.2397 1 2.58381 1 3V18.2412Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelection);
export default __webpack_public_path__ + "static/media/selection.97401bce385aee3912711967b295a48c.svg";
export { ForwardRef as ReactComponent };